import { type IObservableValue, observable, runInAction } from "mobx"
import { startWith } from "rxjs"

import type { Lifetime } from "@/lib/Lifetime.ts"
import type { Observable } from "rxjs"

export interface IRemoteLogModel {
  available: IObservableValue<boolean>
  id: string,
  label: string,
  getLogs: () => Observable<string>
}

export class RemoteLogModel implements IRemoteLogModel {
  private oldLog = ""
  private logs: Observable<string>
  readonly available = observable.box(false)

  constructor(
    readonly id: string,
    readonly label: string,
    subscriber: () => Observable<string>,
    private lifetime: Lifetime
  ) {
    const logs = subscriber()
    this.logs = logs

    this.lifetime.add(logs.subscribe(line => {
      this.oldLog += line
    }), "RemoteLogModel:logs")
    runInAction(() => this.available.set(true))
  }

  getLogs = () => {
    return this.logs.pipe(startWith(this.oldLog))
  }
}